import { PartyType } from '../../models/consultation/cash-sale.model';
export class BookingDetailsModel {
    public id: string;
    public bookingREF: any;
    public date: any;
    public fromTime: any;
    public toTime: any;
    public clinic: string;
    public startTime : string;
    public endTime : string;
    public numberOfAttending: number;
    public travelDestination: Array<any>;
    public note: string;
    public departDate: string;
    public returnDate: string;
    public reason: string = null;
    public reasonsForTrip: string;
    public typeOfAccommodation: string;
    public groupName: string;
    public paymentTerm: string;
    public status: any;
    public clinicId: number = null;
    public listMembers: any[];
    public bookingType: number = PartyType.Individual;
    public centreId: any;
    public clinicName: string;
    public typeOfAccommodationId: any;
    public travelDestinationId: Array<any>;
    public reasonsForTripId: any;
    public typeOfAccommodationName: any;
    public travelDestinationName: any;
    public reasonsForTripName: any;
    public durationId: string = null;
    public duration: number = null;
    public administeredDate: any;
    public destination: any;
    public staffs: any[];
    public IsSaveFluBooking : any;
}
export class CalendarModel {
    public bookingList: any[];
    public disableDates: any[];
    public disableTimes: any[];
  //  public dateSchedules: any[];
}

export enum BookingStatus {
    NewBooking = 0,
    Confirmed = 1,
    Arrived = 2,
    DNA = 3,
    Cancelled = 4,
    FLu = 5
 //   Block = 6
}

export class BookingDetailsFluVaccineModel {
    public id: string;
    public bookingRef: any;
    public administeredDate: any;
    public fromTime: any;
    public toTime: any;
    public groupName: string;
    public members: any[];
}

export class AddTMBStaffModel {
    public id: string;
    public staffName: string;
    public role: string;
}

export class ImportFormModel {
    public isFileDelete: boolean;
    public fileName: string;
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/booking/booking-details.model.ts